/**
 * countdown-bar.js
 * Custom element — timer regressivo no header.
 * Valores iniciais vêm do Liquid (SSR); JS só atualiza a cada segundo.
 */
class CountdownBar extends HTMLElement {
  connectedCallback() {
    const targetStr = this.dataset.target;
    if (!targetStr) return;

    const target = Date.parse(targetStr.replace(' ', 'T'));
    if (Number.isNaN(target)) {
      console.warn('[countdown-bar] data alvo inválida:', targetStr);
      return;
    }

    this.targetMs = target;
    this.els = {
      d: this.querySelector('[data-cd-days]'),
      h: this.querySelector('[data-cd-hours]'),
      m: this.querySelector('[data-cd-minutes]'),
      s: this.querySelector('[data-cd-seconds]'),
    };

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const diff = this.targetMs - Date.now();
    if (diff <= 0) {
      clearInterval(this.interval);
      const section = this.closest('.shopify-section');
      if (section) {
        section.hidden = true;
        section.style.display = 'none';
      } else {
        this.hidden = true;
        this.style.display = 'none';
      }
      return;
    }

    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff / 3600000) % 24);
    const m = Math.floor((diff / 60000) % 60);
    const s = Math.floor((diff / 1000) % 60);
    const pad2 = (n) => String(n).padStart(2, '0');

    if (this.els.d) this.els.d.textContent = String(d);
    if (this.els.h) this.els.h.textContent = pad2(h);
    if (this.els.m) this.els.m.textContent = pad2(m);
    if (this.els.s) this.els.s.textContent = pad2(s);
  }
}

if (!customElements.get('countdown-bar')) {
  customElements.define('countdown-bar', CountdownBar);
}
